import * as React from "react"
import { clsx } from "clsx"
import {
  MenuPopover,
  MenuPopoverProps,
  MenuList,
  MenuListProps,
  MenuItems,
  MenuItemsProps,
  MenuItem,
  MenuItemProps,
  MenuLink,
  MenuLinkProps,
  useMenuButtonContext,
} from "@reach/menu-button"
import { IconType } from "react-icons"
import { forwardRefWithAs } from "@reach/utils"
import * as styles from "./styles.css"

export function DropdownItems(props: MenuListProps) {
  return <MenuList className={styles.dropdown} {...props} />
}

export function DropdownMenuItemsLowLevel(props: MenuItemsProps) {
  return <MenuItems className={styles.dropdown} {...props} />
}

export type DropdownItemProps = MenuItemProps & {
  icon?: IconType
  isCritical?: boolean
  className?: string
}

export const DropdownItem: React.FC<DropdownItemProps> = ({
  children,
  icon: Icon,
  className,
  isCritical,
  ...rest
}) => (
  <MenuItem
    className={clsx(styles.item, isCritical && styles.criticalItem, className)}
    {...rest}
  >
    {Icon && (
      <Icon
        className={clsx(styles.itemIcon, isCritical && styles.criticalIcon)}
      />
    )}
    {children}
  </MenuItem>
)

export type DropdownLinkProps = MenuLinkProps & {
  icon?: IconType
  className?: string
}

export const DropdownLink = forwardRefWithAs<DropdownLinkProps, "a">(
  function DropdownLink({ children, icon: Icon, className, ...rest }, ref) {
    return (
      <MenuLink
        ref={ref}
        className={clsx(
          styles.item,

          className
        )}
        {...rest}
      >
        {Icon && <Icon className={styles.itemIcon} />}
        {children}
      </MenuLink>
    )
  }
)

export type DropdownPopoverProps = MenuPopoverProps

export function DropdownPopover(props: DropdownPopoverProps) {
  return <MenuPopover {...props} />
}

export function useDropdownContext() {
  return useMenuButtonContext()
}

export type DropdownDividerProps = React.ComponentPropsWithoutRef<"hr">

export function DropdownDivider(props: DropdownDividerProps) {
  return <hr {...props} />
}

export type DropdownHeaderProps = React.ComponentPropsWithoutRef<"strong">
export const DropdownHeader = (props: DropdownHeaderProps) => (
  <strong {...props} />
)
